import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Stack,
  MenuItem,
} from '@mui/material';

import CampaignIcon from '@mui/icons-material/Campaign';
import InfoIcon from '@mui/icons-material/Info';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CelebrationIcon from '@mui/icons-material/Celebration';

import Breadcrumb from './BreadCrump';
import TopNav from './Navbar';
import LeftNavbar from './LeftNav';

const CreateAnnouncement = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState('InfoIcon');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('http://196.216.9.34:5020/api/announcements', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title, description, icon }),
      });
      if (res.ok) {
        alert('Announcement created successfully!');
        setTitle('');
        setDescription('');
        setIcon('InfoIcon');
      } else {
        console.error('Failed to create announcement');
      }
    } catch (err) {
      console.error('Error creating announcement:', err);
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Left Navigation */}
      <LeftNavbar />

      {/* Main content wrapper */}
      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        {/* Top Navigation */}
        <TopNav />

        {/* Content */}
        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Create Announcement" />
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: '#ff6600', mb: 4 }}
          >
            <CampaignIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Create Announcement
          </Typography>

          <Card sx={{ boxShadow: 3 }}>
            <CardContent>
              <form onSubmit={handleSubmit}>
                <Stack spacing={3}>
                  <TextField
                    label="Title"
                    variant="outlined"
                    fullWidth
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />

                  <TextField
                    label="Description"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  />

                  <TextField
                    select
                    label="Icon"
                    value={icon}
                    onChange={(e) => setIcon(e.target.value)}
                    fullWidth
                  >
                    <MenuItem value="InfoIcon">
                      <InfoIcon sx={{ mr: 1 }} /> Info
                    </MenuItem>
                    <MenuItem value="AccessTimeIcon">
                      <AccessTimeIcon sx={{ mr: 1 }} /> Reminder
                    </MenuItem>
                    <MenuItem value="CelebrationIcon">
                      <CelebrationIcon sx={{ mr: 1 }} /> Celebration
                    </MenuItem>
                  </TextField>

                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ bgcolor: '#ff6600', '&:hover': { bgcolor: '#e65c00' } }}
                  >
                    Publish Announcement
                  </Button>
                </Stack>
              </form>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default CreateAnnouncement;
